import React, { useEffect, useState } from 'react';
/* import { useHistory } from 'react-router-dom'; */
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { Box, Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import GridContainer from '@jumbo/components/GridContainer';
/* import LinkList from '@jumbo/components/LinkList'; */
import { /* FICHAS_TECNICAS_LINK_LIST_BUTTONS, */ ordenarEquipamientoGeneralPrimero, removeDuplicates, TEXTO_FICHAS_TECNICAS } from '../ConstsAndUtils/utils';
//import { ResponsiveContainer } from 'recharts';
import tableStyle from '@jumbo/components/CustomTable/table.style';
import { Business, Edit, PersonAdd, Warning } from '@material-ui/icons';
//import { deleteFichaTecnica } from 'services/api';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import { useHistory } from 'react-router-dom';
import DashboardCard from './SharedForms/DashboardCard';
import { AddToQueue, Assignment } from '@material-ui/icons';
import { CORP_BLUE, GESTION_C_I, GESTION_EQ, GESTION_FT, GESTION_PER } from 'config/config';
import { getPrestIntSer, postUserLog } from 'services/api';
//import { Percent } from '@mui/icons-material';

const ConFicha = props => {
  const { datosFicha } = props;
  const classes = tableStyle();

  const history = useHistory();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const roles_user = user.roles_user
  const [linkEquipamiento, setLinkEquipamiento] = useState('')
  const [disableBtn, setDisableBtn] = useState(true)



  //const [porcentaje, setPorcentaje] = useState(0);
  /*   const [diasFaltantes, setDiasFaltantes] = useState(0); */
  // const [datos, setDatos] = useState([]);

  /*   const mockUpData = [
      {
        nombre: 'Nombre de prueba',
        tipo: '03/11/2023',
        ingreso: 'xxxxxx',
        estado: 'En progreso',
      },
    ]; */
  useEffect(() => {
    //setDatos(mockUpData);
    //setPorcentaje(23)
    //eslint-disable-next-line react-hooks/exhaustive-deps
    if (!!datosFicha.identidad.id_tipo_prestador) {
      getPrestIntSer(datosFicha.identidad.id_tipo_prestador)
        .then(res => {
          let item = getEquipamientoFirstLink(res.data.servicios_medicos, datosFicha.identidad.id_tipo_prestador)

          sessionStorage.setItem('idNav', item[0].id)
          setLinkEquipamiento(item[0].link)
        })
        .catch(err => console.error(err))
        .finally(f => {
          setDisableBtn(false)
        })
    }
  }, [datosFicha]);

  /*   const auxCloseForm = () => {
      setShowConFicha(false);
      setShowForm(true);
    }; */

  /*   const renderTableBody = () => {
      return datos.map((item, index) => {
        return (
          <TableRow key={index}>
            <TableCell>{item.nombre}</TableCell>
            <TableCell>
              <div style={{ backgroundColor: '#aa0000', borderRadius: '10px', padding: '2px 5px', display: 'inline-block' }}>
                <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                  <Info />
                  <p style={{ margin: '0', paddingLeft: '5px' }}>{item.tipo}</p>
                </div>
              </div>
            </TableCell>
            <TableCell>{item.ingreso}</TableCell>
            <TableCell>{item.estado}</TableCell>
            <TableCell align="center">
              <Edit
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  auxCloseForm();
                }}
              />
            </TableCell>
          </TableRow>
        );
      });
    }; */

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const getEquipamientoFirstLink = (servicios, prestador) => {

    let auxservs = removeDuplicates(servicios)
    let auxservs2 = ordenarEquipamientoGeneralPrimero(auxservs)
    let auxArr2 = []

    auxservs2.map((servicio, index) => {


      if (servicio.nombre_logico !== "servicio-apoyo" && !servicio.is_equip) {

        if (servicio.equipamiento.length > 0) {
          auxArr2.push({
            name: servicio.nombre,
            type: 'item',
            link: '/ft-eq-' + servicio.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
            id: servicio.id
          })
        }

      } else if (servicio.is_equip) {

        if (!!servicio.tipo_prestadores_institucional.find(e => e.id === parseInt(prestador))) {
          if (servicio.equipamiento.length > 0) {
            auxArr2.push({
              name: servicio.nombre,
              type: 'item',
              link: '/ft-eq-' + servicio.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
              id: servicio.id
            })
          }
        }

      }
      else {

        servicio.servicios_internos.map((servicio_interno, index2) => {
          if (servicio_interno.equipamiento.length > 0) {
            auxArr2.push({
              name: servicio_interno.nombre,
              type: 'item',
              link: '/ft-eq-' + servicio_interno.nombre_logico.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').trim(),
              id: servicio_interno.id
            })
          }

          return null
        })


      }
      return null
    })
    return auxArr2
  }

  return (
    <GridContainer>
      <CustomToast />
      <Grid item xs={12}>
        <div style={{ marginBottom: 10 }}>
          <h1 style={{ padding: 15 }}>
            Ingreso y actualización de datos en ficha técnica para Prestadores Institucionales
          </h1>
          <p style={{ paddingLeft: 15, paddingRight: 15 }}>{TEXTO_FICHAS_TECNICAS}</p>
        </div>
        <Divider />
        <br />
      </Grid>

      {history.location.pathname === "/fichas_tecnicas" ?
        <>
          {/*           <Grid item xs={12}>
            <Grid
              item
              xs={12}
              style={{
                background: '#00a2e8',
                padding: 10,
                borderRadius: 15,
                cursor: 'pointer',
              }}>
              <ResponsiveContainer width="100%" height={100}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  onClick={() => {
                    //history.push('/porcentaje-de-avance');
                  }}>
                  <div style={{ padding: 5, color: 'whitesmoke' }}>
                    <Percent style={{ fontSize: 45 }} />
                  </div>
                  <div
                    style={{
                      padding: 5,
                      fontSize: 20,
                      color: 'whitesmoke',
                      fontWeight: 'bold',
                    }}>
                    <div>Porcentaje de Avance</div>
                    <div style={{ textAlign: 'end' }}>{porcentaje + ' %'}</div>
                  </div>
                </Box>
              </ResponsiveContainer>
            </Grid>
          </Grid> */}

          {
            datosFicha.estado.id === 2 ?
              <Grid item xs={12} container>
                <div>
                  <Warning
                    color="error"
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                  <p>Mientras la ficha esté en revisión (estado Ingresada) no se puede editar.</p>
                </div>
              </Grid>
              :
              null
          }

          <Grid item xs={12}>
            <Box className={classes.root}>
              <Paper className={classes.paper}>
                <p style={{ padding: 16, fontWeight: 'bold', fontSize: '1.75rem' }}> Registros Activos</p>
                <TableContainer>
                  <Table stickyHeader className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre Prestador</TableCell>
                        <TableCell>Fecha de Creación</TableCell>
                        <TableCell>Fecha última actualización</TableCell>
                        <TableCell>Estado</TableCell>
                        {datosFicha.estado.id === 2 ?
                          //null
                          <TableCell align="center">{datosFicha.estado.id === 4 ? "Actualizar" : "Editar"}</TableCell>
                          :
                          <TableCell align="center">{datosFicha.estado.id === 4 ? "Actualizar" : "Editar"}</TableCell>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow >
                        <TableCell>{datosFicha.identidad.nombre_prestador}</TableCell>
                        <TableCell>

                          {formatDate(datosFicha.creado)}


                        </TableCell>
                        <TableCell>{
                          datosFicha.actualizado ?
                            formatDate(datosFicha.actualizado) : 'Aún no se realiza actualización'
                        }</TableCell>
                        <TableCell>{
                          datosFicha.estado.nombre
                          //'En progreso'
                        }</TableCell>

                        {
                          datosFicha.estado.id === 2 ?
                            //null
                            <TableCell align="center">
                              <Button
                                disabled={disableBtn}
                                variant='outlined'
                                style={{ backgroundColor: disableBtn ? '#dddddd' : 'green', color: 'white' }}
                                onClick={() => {

                                  //auxCloseForm();
                                  if (datosFicha.estado.id === 4) {

                                  } else {
                                    //console.log('roles_user',roles_user)
                                    let bodyFormData = { "id_ficha_tecnica": sessionStorage.getItem('idFicha') }
                                    postUserLog(bodyFormData)
                                      .then(res => {
                                      })
                                      .catch(e => { console.error(e) })
                                      .finally(f => {
                                      })
                                    if (roles_user.some(role => role.name === GESTION_FT)) {
                                      history.push('/ft-identificacion-prestador')
                                    } else if (roles_user.some(role => role.name === GESTION_C_I)) {
                                      history.push('/ft-autorizacion-sanitaria')
                                    } else if (roles_user.some(role => role.name === GESTION_EQ)) {
                                      history.push(linkEquipamiento)
                                    } else if (roles_user.some(role => role.name === GESTION_PER)) {
                                      history.push('/ft-dotacion-personal')
                                    } else {
                                      toast.warn("No posee roles para editar la ficha técnica.")
                                    }

                                  }
                                }}
                              >
                                {
                                  disableBtn ?
                                    <CircularProgress
                                      color='primary'
                                      size='1.5rem'
                                    />
                                    :
                                    <Edit />}
                              </Button>

                            </TableCell>
                            :
                            <TableCell align="center">
                              <Button
                                disabled={disableBtn}
                                variant='outlined'
                                style={{ backgroundColor: disableBtn ? '#dddddd' : 'green', color: 'white' }}
                                onClick={() => {

                                  //auxCloseForm();
                                  if (datosFicha.estado.id === 4) {

                                  } else {
                                    //console.log('roles_user',roles_user)
                                    let bodyFormData = { "id_ficha_tecnica": sessionStorage.getItem('idFicha') }
                                    postUserLog(bodyFormData)
                                      .then(res => {
                                      })
                                      .catch(e => { console.error(e) })
                                      .finally(f => {
                                      })
                                    if (roles_user.some(role => role.name === GESTION_FT)) {
                                      history.push('/ft-identificacion-prestador')
                                    } else if (roles_user.some(role => role.name === GESTION_C_I)) {
                                      history.push('/ft-autorizacion-sanitaria')
                                    } else if (roles_user.some(role => role.name === GESTION_EQ)) {
                                      history.push(linkEquipamiento)
                                    } else if (roles_user.some(role => role.name === GESTION_PER)) {
                                      history.push('/ft-dotacion-personal')
                                    } else {
                                      toast.warn("No posee roles para editar la ficha técnica.")
                                    }

                                  }
                                }}
                              >
                                {
                                  disableBtn ?
                                    <CircularProgress
                                      color='primary'
                                      size='1.5rem'
                                    />
                                    :
                                    <Edit />}
                              </Button>

                            </TableCell>
                        }

                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>
          </Grid>

        </>
        :
        <Grid container item xs={12} >
          <DashboardCard
            value={87}
            text={"Identificación del Prestador"}
            link={'/ft-identificacion-prestador'}
            icon={<Assignment style={{ fontSize: 80, color: CORP_BLUE }}
            />}
          />
          <DashboardCard
            value={90}
            text={"Capacidad instalada"}
            link={'/ft-autorizacion-sanitaria'}
            icon={<Business style={{ fontSize: 80, color: CORP_BLUE }}
            />}
          />

          <DashboardCard
            value={54}
            text={"Equipamiento"}
            link={'/ft-equipo-para-unidad-intensivo-adulto-/pediatrica'}
            icon={<AddToQueue style={{ fontSize: 80, color: CORP_BLUE }}
            />}
          />
          <DashboardCard
            value={12}
            text={"Dotación personal"}
            link={'/ft-dotacion-personal'}
            icon={<PersonAdd style={{ fontSize: 80, color: CORP_BLUE }}
            />}
          />
        </Grid>
      }

      <CustomToast />
    </GridContainer>
  );
};

export default ConFicha;
